const state = {
  messages: []
}

const defaultOptions = {
  variant: 'primary',
  isDismissible: true
}

const actions = {
  showMessage ({ commit }, messageData) {
    const { title, route, icon, isToast = false, autoHideDelay = 0, options = {} } = messageData
    const identifier = Math.random().toString(36).substring(2, 10)

    commit('addMessage', { identifier, title, route, icon, isToast, options: Object.assign({ }, defaultOptions, { 'time': autoHideDelay }, options) })

    if (autoHideDelay) {
      setTimeout(() => { commit('removeMessage', identifier) }, autoHideDelay)
    }
  },

  showToastMessage ({ dispatch }, toastData) {
    dispatch('showMessage', { isToast: true, autoHideDelay: 5000, ...toastData })
  },

  removeMessage ({ commit }, identifier) {
    commit('removeMessage', identifier)
  }
}

const mutations = {
  addMessage (state, message) {
    state.messages.unshift(message)
  },

  removeMessage (state, identifier) {
    state.messages = state.messages.filter(item => item.identifier !== identifier)
  }
}

export default {
  state,
  actions,
  mutations
}
